import Alert from "./Alert";

export default function EnableEpicOutlookIntegrationAlert() {
  return <Alert variant="red">
    <svg xmlns="http://www.w3.org/2000/svg" className="tw-h-5 tw-w-5 tw-inline tw-mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
    <a href="/" className="tw-font-bold">Enable Epic/Outlook Integration</a>
  </Alert>
}